(function () {
    'use strict';
    var controllerId = 'cndPartecipAnnulled';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partecipazione', cndPartecipAnnulled]);

    function cndPartecipAnnulled($scope, datacontext, $uibModalInstance, partecipazione) {
        $scope.record = jQuery.extend({}, partecipazione); //Clona oggetto
        $scope.nominativo = 'ID: ' + $scope.record.Id + ' del Soggetto Proponente: ' + $scope.record.APL;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.partecipazione_setAnnulled(item.Id, true, $scope.noteAnnulled).then(function (data) {
                return data;
            });
        }

    }
})();